import React from "react";

const ConfidenceLabel = ({ confidence }) => {
  if (!confidence || !confidence.exists) return null;
  return (
    <span style={{
      color:      confidence.color,
      fontSize:   "0.75rem",
      fontWeight: 500,
      marginLeft: "6px",
    }}>
      (confiance {Math.round(confidence.value * 100)}%)
    </span>
  );
};

export default ConfidenceLabel;